import { createContext } from 'react';

export const SankeyFormatterContext =
  createContext<(value: number) => string>(String);
